<script lang="ts">
  import { Button } from "$lib/components/ui/button"
  import { APP_CODE, APP_VERSION } from "$lib/env"
  import { deviceStore } from "$lib/stores/device-store.svelte"
  import ArrowLeftIcon from "@lucide/svelte/icons/arrow-left"

  const device = $derived(deviceStore.device)

  const {
    title,
    message
  } = $props<{
    title: string,
    message: string
  }>()

</script>
<main class="relative flex h-full w-full flex-col items-center justify-center">
  <div class="absolute top-4 inset-e-4 text-end font-mono text-xs font-light text-gray-800">
    <div>{APP_CODE}-{APP_VERSION}</div>
    <div>{device.device_id.toUpperCase().substring(0, 16)}</div>
  </div>
  <section class="flex w-80 flex-col text-center space-y-6">
    <div>
      <h3 class="text-xl font-bold text-primary">
        {title}
      </h3>
      <p class="text-sm text-muted-foreground">
        {message}
      </p>
    </div>
    <div class="flex justify-center gap-2">
      <Button href="/home"
              variant="outline"
              class="rounded-full">
        <ArrowLeftIcon/>
        Ke Halaman Utama
        <div></div>
      </Button>
    </div>
  </section>
</main>